import type { AgentComponentType } from '@reach/shared-types/agent-components';
import { Link } from 'react-router-dom';
import { componentListPath } from '../agent-component-paths';
import { COMPONENT_TYPE_COPY, STATUS_COPY } from '../agents-copy';
import { StatusNote } from '../StatusNote';
import { useAgentComponent } from '../useAgentComponents';
import { COMPONENT_PAGE_COPY } from './component-page-copy';
import { ComponentEditor } from './ComponentEditor';

interface SavedComponentEditorProps {
  type: AgentComponentType;
  componentId: string;
}

export const SavedComponentEditor = ({ type, componentId }: SavedComponentEditorProps) => {
  const { data: component, isLoading, isError } = useAgentComponent(type, componentId);

  if (isLoading) {
    return <StatusNote>{STATUS_COPY.loading}</StatusNote>;
  }
  if (isError) {
    return <StatusNote tone="error">{COMPONENT_TYPE_COPY[type].loadErrorNote}</StatusNote>;
  }
  if (!component) {
    const notFoundMessage = (
      <>
        {COMPONENT_TYPE_COPY[type].notFound}{' '}
        <Link to={componentListPath(type)}>{COMPONENT_PAGE_COPY.backToList}</Link>
      </>
    );
    return <StatusNote>{notFoundMessage}</StatusNote>;
  }
  // Keyed by the save time so a refetched component restarts the editor from what was saved.
  return <ComponentEditor key={component.updatedAt} type={type} component={component} />;
};
